module.exports = __webpack_public_path__ + "img/zoomout.207fd70b.svg";